
// 1 (800) 555-1212
// 18005551212
// 1-800-555-1212
// 1 800 555 1212
// + more, read & consider pattern
exports.phone 						= 		/^(1(-|\s)?)?\(?[2-9]{1}\d{2}\)?(-|\s)?\d{3}(-|\s)?\d{4}$/;

// 18005551212
exports.phoneStrict 			= 		/^1\d{3}\d{3}\d{4}$/;